var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Yes",
    transform: "translate(0.254 0.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Checkbox",
    d: "M7.786,14.5,1,7.257,2.61,5.539l5.176,5.4L17.1,1l1.61,1.718Z",
    transform: "translate(-1.111 0.806)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_556",
    "data-name": "Rectangle 556",
    width: 18,
    height: 18,
    transform: "translate(-0.254 -0.255)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCheck);
export default __webpack_public_path__ + "static/media/bigCheck.cc03cda939e4a18278da926a310419c8.svg";
export { ForwardRef as ReactComponent };